import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import LandingPage from '@pages/common/LandingPage';

const LandingOrRedirect: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return <LandingPage />;
  }

  if (location.pathname !== '/') {
    return null;
  }

  switch (user.role) {
    case 'master_admin':
      return <Navigate to="/master-admin" replace />;
    case 'clinic_admin':
      return <Navigate to="/clinic" replace />;
    case 'veterinarian':
    case 'doctor':
      return <Navigate to="/doctor" replace />;
    case 'reception':
    case 'receptionist':
      return <Navigate to="/receptie" replace />;
    case 'shelter_admin':
    case 'shelter_staff':
      return <Navigate to="/shelter" replace />;
    case 'client':
    default:
      return <Navigate to="/dashboard" replace />;
  }
};

export default LandingOrRedirect;
